let enabled = false;
const data: { [key: string]: string } = {};

try {
	const name = "test";
	const value = "value";

	localStorage.setItem(name, value);
	enabled = localStorage.getItem(name) === value;
} catch (ex) {
	//
}

export function setItem(name: string, value: string): void {
	if (enabled) {
		try {
			localStorage.setItem(name, value);
		} catch (ex) {
			//
		}
	} else {
		data[name] = value;
	}
}

export function getItem(name: string): string {
	if (enabled) {
		try {
			return localStorage.getItem(name);
		} catch (ex) {
			return "";
		}
	} else {
		return data[name];
	}
}

export function removeItem(name: string): void {
	if (enabled) {
		try {
			localStorage.removeItem(name);
		} catch (ex) {
			//
		}
	} else if (name in data) {
		delete data[name];
	}
}
